import { useEffect } from 'react';
import type { RefObject } from 'react';
import { getNodeClickSelection } from '../core';
import { useStoreApi } from '../store';
import { isMultiSelectEvent } from '../utils';

/** Selects a node on click when it cannot be dragged (draggable nodes are selected when a drag starts — v11). */
export const useNodeClickSelect = (nodeRef: RefObject<HTMLElement>, id: string, isEnabled: boolean): void => {
  const store = useStoreApi();
  useEffect(() => {
    const element = nodeRef.current;
    if (!element || !isEnabled) return undefined;
    const handleClick = (event: MouseEvent) => {
      const { nodes, edges, applySelection } = store.getState();
      applySelection(getNodeClickSelection(nodes, edges, id, isMultiSelectEvent(event)));
    };
    element.addEventListener('click', handleClick);
    return () => element.removeEventListener('click', handleClick);
  }, [nodeRef, id, isEnabled, store]);
};
